export const dashboardConstants = {
  GET_DASHBOARD_DATA_REQUEST: 'DASHBOARD/GET_DASHBOARD_DATA_REQUEST',
  GET_DASHBOARD_DATA_SUCCESS: 'DASHBOARD/GET_DASHBOARD_DATA_SUCCESS',
  GET_DASHBOARD_DATA_FAILURE: 'DASHBOARD/GET_DASHBOARD_DATA_FAILURE',

  ACCEPT_SUGGEST_MIXR_REQUEST: 'DASHBOARD/ACCEPT_SUGGEST_MIXR_REQUEST',
  ACCEPT_SUGGEST_MIXR_SUCCESS: 'DASHBOARD/ACCEPT_SUGGEST_MIXR_SUCCESS',
  ACCEPT_SUGGEST_MIXR_FAILURE: 'DASHBOARD/ACCEPT_SUGGEST_MIXR_FAILURE',

  REJECT_SUGGEST_MIXR_REQUEST: 'DASHBOARD/REJECT_SUGGEST_MIXR_REQUEST',
  REJECT_SUGGEST_MIXR_SUCCESS: 'DASHBOARD/REJECT_SUGGEST_MIXR_SUCCESS',
  REJECT_SUGGEST_MIXR_FAILURE: 'DASHBOARD/REJECT_SUGGEST_MIXR_FAILURE',

  ACCEPT_NEW_MEMBER_REQUEST: 'DASHBOARD/ACCEPT_NEW_MEMBER_REQUEST',
  ACCEPT_NEW_MEMBER_SUCCESS: 'DASHBOARD/ACCEPT_NEW_MEMBER_SUCCESS',
  ACCEPT_NEW_MEMBER_FAILURE: 'DASHBOARD/ACCEPT_NEW_MEMBER_FAILURE',

  REJECT_NEW_MEMBER_REQUEST: 'DASHBOARD/REJECT_NEW_MEMBER_REQUEST',
  REJECT_NEW_MEMBER_SUCCESS: 'DASHBOARD/REJECT_NEW_MEMBER_SUCCESS',
  REJECT_NEW_MEMBER_FAILURE: 'DASHBOARD/REJECT_NEW_MEMBER_FAILURE',

  REMOVE_NEW_MEMBER_REQUEST: 'DASHBOARD/REMOVE_NEW_MEMBER_REQUEST',
  REMOVE_NEW_MEMBER_SUCCESS: 'DASHBOARD/REMOVE_NEW_MEMBER_SUCCESS',
  REMOVE_NEW_MEMBER_FAILURE: 'DASHBOARD/REMOVE_NEW_MEMBER_FAILURE',

  CANCEL_INVITATION_REQUEST: 'DASHBOARD/CANCEL_INVITATION_REQUEST',
  CANCEL_INVITATION_SUCCESS: 'DASHBOARD/CANCEL_INVITATION_SUCCESS',
  CANCEL_INVITATION_FAILURE: 'DASHBOARD/CANCEL_INVITATION_FAILURE',

  RENEW_INVITATION_REQUEST: 'DASHBOARD/RENEW_INVITATION_REQUEST',
  RENEW_INVITATION_SUCCESS: 'DASHBOARD/RENEW_INVITATION_SUCCESS',
  RENEW_INVITATION_FAILURE: 'DASHBOARD/RENEW_INVITATION_FAILURE',

  RENEW_ALL_INVITATION_REQUEST: 'DASHBOARD/RENEW_ALL_INVITATION_REQUEST',
  RENEW_ALL_INVITATION_SUCCESS: 'DASHBOARD/RENEW_ALL_INVITATION_SUCCESS',
  RENEW_ALL_INVITATION_FAILURE: 'DASHBOARD/RENEW_ALL_INVITATION_FAILURE',

  CLEAR_DATA: 'DASHBOARD/CLEAR_DATA'
}
